/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */

import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const section12MedicalTypes = [
    MedicalTypeIds.Skin,
    MedicalTypeIds.SkinFaceToFace,
    MedicalTypeIds.Audiometry,
    MedicalTypeIds.RespiratorySensitiser,
    MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1,
    MedicalTypeIds.RespiratorySensitiserQuestionnaireLevel1,
    MedicalTypeIds.HAVS,
    MedicalTypeIds.HAVSFaceToFace,
    MedicalTypeIds.IonisingRadiation,
    MedicalTypeIds.IonisingRadiationFaceToFace,
    MedicalTypeIds.BiologicalMonitoring,
    MedicalTypeIds.OtherSurveillance,
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.GroupOneDriving,
    MedicalTypeIds.GroupTwoDriving,
    MedicalTypeIds.WorkAtHeight,
    MedicalTypeIds.WorkingConfinedSpaces,
    MedicalTypeIds.WearingRPE,
    MedicalTypeIds.WearingBreathingApparatus,
    MedicalTypeIds.WorkingThermalEnvironment,
    MedicalTypeIds.NightWorker,
    MedicalTypeIds.LoneWorker,
    MedicalTypeIds.FoodHandlerQuestionsOnly,
    MedicalTypeIds.DSE,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork,
    MedicalTypeIds.ManualHandlingMSKQuestionnaire,
    MedicalTypeIds.ManualHandlingMSKFaceToFaceAppointment,
    MedicalTypeIds.AmzPitPupMedical,
    MedicalTypeIds.AmzPitPupHealthDeclaration,
    MedicalTypeIds.LAAWorker,
    MedicalTypeIds.FieldForce,
    MedicalTypeIds.SkinLevel1,
    MedicalTypeIds.SkinFaceToFaceLevel1,
    MedicalTypeIds.SkinAssessmentLevel2
];

/* eslint-disable max-len */
/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
const section12Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.Declaration1,
        questionText: "I declare that the information I have provided in this form is true and accurate to the best of my belief and knowledge.",
        medicalTypes: section12MedicalTypes
    }
];

export { section12Questions };
/* eslint-enable max-len */
